import * as Sentry from '@sentry/remix';

export type NotificationProduct = {
  product_id: string;
  sizes: string[];
};

export const PENDING_REGISTRATION_EMAIL_KEY = 'pendingRegistrationEmail';

export const PENDING_REGISTRATION_EMAIL_CHANGED_EVENT =
  'pending-registration-email-changed';

function emitPendingRegistrationEmailChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(PENDING_REGISTRATION_EMAIL_CHANGED_EVENT));
  }
}

export function getPendingRegistrationEmail(): string | null {
  try {
    return localStorage.getItem(PENDING_REGISTRATION_EMAIL_KEY);
  } catch {
    return null;
  }
}

export function setPendingRegistrationEmail(email?: string) {
  if (!email) return;

  try {
    localStorage.setItem(PENDING_REGISTRATION_EMAIL_KEY, email.toLowerCase());
    emitPendingRegistrationEmailChanged();
  } catch (error) {
    Sentry.captureException(error, {
      tags: { feature: 'pending-registration-confirmation' }
    });
  }
}

export function clearPendingRegistrationEmail() {
  try {
    localStorage.removeItem(PENDING_REGISTRATION_EMAIL_KEY);
    emitPendingRegistrationEmailChanged();
  } catch {
    // localStorage unavailable — nothing to clear
  }
}

export function getBrowser(userAgent: string | null) {
  const match = userAgent?.match(/firefox|chrome|safari|instagram|msie/i);

  if (!match) return 'unknown';

  const [browser] = match;

  return browser!.toLowerCase();
}

export function isAppleMobileDevice(userAgent: string | null) {
  if (!userAgent) return false;

  return /iPhone|iPad|iPod/i.test(userAgent);
}

export function isInAppBrowser(userAgent: string = '') {
  return /instagram|fban|fbav|twitter/i.test(userAgent);
}

export function buildNotificationProducts(
  productId?: string | number,
  sizes: string[] = ['ALL']
): NotificationProduct[] {
  const id = Number(productId);

  if (!id) return [];

  return [{ product_id: String(id), sizes: sizes.length ? sizes : ['ALL'] }];
}
